import { Image } from "@/components/r3f-components";
import { ITrackingImageFileData } from "@/zustand"
import React, { FunctionComponent, memo } from "react";

interface IParentProps {
    imageTrackingData: ITrackingImageFileData;
}

const TrackingImageRepresentation: FunctionComponent<IParentProps> = ({imageTrackingData}) => {
    return <Image
        id={`tracking-image-preview-${imageTrackingData.filestoreId}`}
        rotation={[0, 0, 0]}
        renderOrder={0}
        scale={imageTrackingData.scale ?? [0, 0, 0]}
        position={[0, 0, -0.001]}
        imageUrl={imageTrackingData.imageUrl}
        curvature={imageTrackingData.bottomRadius ?? 0}
        borderWidth={0}
        borderRadius={0}
        hasAlpha={false}
        opacity={1}
        castShadow={true}
        receiveShadow={true}
    />
}

TrackingImageRepresentation.displayName = 'TrackingImageRepresentation';
export default memo(TrackingImageRepresentation);